import { SystemInfoListItem } from "./components/SystemInfoListItem.js";
import { useMemo } from "react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { getFormattedRelativeDate } from "@therms/web-js";
import classnames from "classnames";
//#region src/modules/SystemInfo/shared/components/SystemInfosList/index.tsx
function SystemInfosList({ onItemClick, systemInfos }) {
	const systemInfosByDate = useMemo(() => {
		if (Array.isArray(systemInfos) && systemInfos.length) return systemInfos.reduce((acc, changelog) => {
			const formattedDate = getFormattedRelativeDate(changelog.publishDate);
			if (!acc[formattedDate]) acc[formattedDate] = [];
			acc[formattedDate].push(changelog);
			return acc;
		}, {});
		return {};
	}, [systemInfos]);
	return /* @__PURE__ */ jsx(Fragment$1, { children: Object.keys(systemInfosByDate).map((date) => /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("div", {
		className: "sticky top-0 z-sticky bg-surface p-xs px-base text-sm font-bold uppercase text-color-subtle",
		children: date
	}), /* @__PURE__ */ jsx("div", {
		className: "grow divide-y divide-border",
		children: systemInfosByDate[date].map((systemInfo) => /* @__PURE__ */ jsx("div", {
			className: classnames("rounded p-base", { "cursor-pointer transition hover:bg-main-faded focus:bg-main-faded active:bg-main-dark": !!onItemClick }),
			onClick: onItemClick ? () => onItemClick(systemInfo) : void 0,
			tabIndex: onItemClick ? 0 : void 0,
			children: /* @__PURE__ */ jsx(SystemInfoListItem, {
				excerpt: systemInfo.excerpt,
				timestamp: systemInfo.publishDate,
				title: systemInfo.title,
				type: systemInfo.type
			})
		}, systemInfo.id))
	})] }, date)) });
}
//#endregion
export { SystemInfosList };

//# sourceMappingURL=index.js.map